<template>
    <v-layout row wrap align-center v-on:keyup.enter="queryAllCourseInfo">
        <v-flex md3>
            <v-text-field :label="labels.course_code"
                          v-model="course_no"
                          :mask="course_no_mask"
                          ></v-text-field>
        </v-flex>
        <v-flex md3>
            <v-text-field :label="labels.course_title"
                          v-model="course_name"></v-text-field>
        </v-flex>
        <v-flex md3>
            <v-text-field :label="labels.instructor"
                          v-model="instructor"></v-text-field>
        </v-flex>
        <v-flex md1>
            <v-btn round
                   block
                   :disabled="btn_state"
                   v-on:click="queryAllCourseInfo()">
                <v-icon>search</v-icon>
                {{ labels.search }}
            </v-btn>
        </v-flex>
        <v-flex md1 xs12>
            <v-btn round v-on:click="ExportExcel">{{ labels.save_excel }}</v-btn>
        </v-flex>
    </v-layout>
</template>

<script>
    import languages from "../../languages/TabArchivedCourse.json";
    import XLSX from "xlsx";
    import excel_languages from "../../languages/Table.json";
    import excelJson from "../../languages/Excel.json";

    export default {
        data: () => ({
            labels: {
                course_code: "",
                course_title: "",
                search: "",
                save_excel: "",
            },
            course_no: "",
            course_no_mask: "NNNNNN",
            course_name: "",
            instructor: "",
        }),
        computed: {
            btn_state() {
                return this.$store.state.btn_state;
            },
            departments() {
                return this.$store.state.departments;
            },
            semesters() {
                return this.$store.state.semesters;
            },
            select_semester: {
                get() {
                    return this.$store.state.select_semester;
                },
                set(value) {
                    this.$store.commit("setSelectSemester", value);
                },
            },
            select_language() {
                return this.$store.state.select_language;
            },
        },
        watch: {
            select_language(value) {
                this.setLanguage(value);
            },
        },
        created() {
            this.setLanguage(this.$store.state.select_language);
        },
        methods: {
            queryAllCourseInfo: function () {
                if (
                    this.course_no == "" &&
                    this.course_name == "" &&
                    this.instructor == ""
                ) {
                    this.$store.commit("showAlert", "請輸入查詢條件!");
                } else {
                    var query_params = {
                        CampusNotes: "",
                        Semester: this.select_semester,
                        CourseNo: this.course_no,
                        CourseName: this.course_name,
                        CourseTeacher: this.instructor,
                        Dimension: "",
                        CourseNotes: "",
                        ForeignLanguage: 0,
                        OnlyGeneral: 0,
                        OnleyNTUST: 0,
                        OnlyMaster: 0,
                        OnlyUnderGraduate: 0,
                        OnlyNode: 0,
                        IsArchivedCourse: true,
                        Language: this.select_language.lang,
                    };
                    this.$store.dispatch("queryCourseInfo", query_params);
                }
            },
            setLanguage: function (select_language) {
                this.labels.course_code = languages.course_code[select_language.lang];
                this.labels.course_title = languages.course_title[select_language.lang];
                this.labels.instructor = languages.instructor[select_language.lang];
                this.labels.search = languages.search[select_language.lang];
                this.labels.save_excel = languages.save_excel[select_language.lang];
            },
            ExportExcel: function () {
                var info_data = JSON.parse(JSON.stringify(this.$store.state.info));
                info_data.forEach((element) => {
                    element[
                        excel_languages.semester[this.$store.state.select_language.lang]
                    ] = element["Semester"];
                    element[
                        excel_languages.course_code[this.$store.state.select_language.lang]
                    ] = element["CourseNo"];
                    element[
                        excel_languages.course_title[this.$store.state.select_language.lang]
                    ] = element["CourseName"];
                    element[
                        excel_languages.credits[this.$store.state.select_language.lang]
                    ] = element["CreditPoint"];
                    element[
                        excelJson.required_elective[this.$store.state.select_language.lang]
                    ] = element["RequireOption"];
                    element[
                        excel_languages.full_half[this.$store.state.select_language.lang]
                    ] = element["AllYear"];
                    element[
                        excel_languages.instructor[this.$store.state.select_language.lang]
                    ] = element["CourseTeacher"];
                    element[
                        excel_languages.total_registered_full[this.$store.state.select_language.lang]
                    ] = element["AllStudent"] + "(" + element["ChooseStudent"] + "/" + element["ThreeStudent"] + ")";//選課總人數 (本校/系統學校)
                    element[
                        excel_languages.day_time[this.$store.state.select_language.lang]
                    ] = element["DayTime"];
                    element[
                        excel_languages.location[this.$store.state.select_language.lang]
                    ] = element["ClassRoomNo"];
                    element[excel_languages.notes[this.$store.state.select_language.lang]] =
                        element["Contents"];

                    delete element["total_students"];
                    delete element["Semester"];
                    delete element["CourseNo"];
                    delete element["CourseName"];
                    delete element["CourseTeacher"];
                    delete element["Dimension"];
                    delete element["CreditPoint"];
                    delete element["RequireOption"];
                    delete element["AllYear"];
                    delete element["ChooseStudent"];
                    delete element["ThreeStudent"];
                    delete element["AllStudent"];
                    delete element["Restrict1"];
                    delete element["Restrict2"];
                    delete element["NTURestrict"];
                    delete element["NTNURestrict"];
                    delete element["CourseTimes"];
                    delete element["PracticalTimes"];
                    delete element["ClassRoomNo"];
                    delete element["Node"];
                    delete element["Contents"];
                    delete element["disable"];
                    delete element["ThreeNode"];
                });
                var wb = XLSX.utils.book_new();
                var ws = XLSX.utils.json_to_sheet(info_data);
                XLSX.utils.book_append_sheet(wb, ws, "sheet1");
                XLSX.writeFile(wb, "out.xlsx");
            },
        },
    };
</script>
